import axios, { AxiosRequestConfig } from "axios";
import { Tokens } from "../../types/webchatConversation";
import getAxiosConfig from "../other/axiosConfig";
import { getCookie } from "../other/cookies";

const registrationHelper = async (
  email: string,
  password: string,
): Promise<string> => {
  const token = getCookie(Tokens.GUEST_TOKEN)
    ? getCookie(Tokens.GUEST_TOKEN)
    : null;
  const configData = {
    email,
    password,
    token,
  };

  const config: AxiosRequestConfig = getAxiosConfig(
    "POST",
    "/users-auth/registration",
    "Content-Type",
    configData,
  );

  const response = await axios(config);

  const { data } = response;
  const { code } = data;

  if (code !== 201) {
    if (code === 409) {
      const { description } = data;
      throw new Error(description);
    }
    throw new Error("Registration failed! Please try again.");
  }

  const { data: jwtAuthToken } = data;
  return jwtAuthToken;
};

export default registrationHelper;
